import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { RootScopeDeclare } from 'src/app/core/rootscope-declare';
import { RFIDMember, RFIDMemberResponse } from 'src/app/core/services/facility.model';
import { FacilityService } from 'src/app/core/services/facility.service';
import { RootScopeService } from 'src/app/core/shared-service/root-scope.service';
import { RfidMemberService } from 'src/app/post-login/services/rfid-member.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-rfid-members',
  templateUrl: './members.component.html',
  styleUrls: ['./members.component.scss'],
})
export class MembersComponent implements OnInit, OnDestroy {
  rootScopeData: RootScopeDeclare;
  showUnsavedModal: boolean = false;
  // subscriptions
  private _facilityOnChange: Subscription;
  currentFacility: any;
  hasEditPermission: boolean= true;

  
  @Input() members: RFIDMember[];  
  @Output() onRefresh: EventEmitter<boolean> = new EventEmitter();

  constructor(
    private _facilityService: FacilityService,
    private _rootScopeService: RootScopeService,
    private _rfidMemberService: RfidMemberService,
    private _router: Router
  ) {}

  ngOnInit(): void {
    this.currentFacility = this._facilityService.selectedFacility();

    // this.getRootScopeData();
    this.getRootScopeData();
    if(this.currentFacility.summary.userRights.facility === 'F')
    this.hasEditPermission = true;
    else
    this.hasEditPermission = false;
 }

  ngOnDestroy(): void {
    this._facilityOnChange?.unsubscribe();
  }

  getRootScopeData(): void {
    this._rootScopeService.getRootScope().subscribe((rootScopeData) => (this.rootScopeData = rootScopeData));
  }
  
  addRFIDMember():void{
    if(this.rootScopeData.isPageHasUnsavedChanges){
      this.openUnsavedModal();
    }else{
      this.rootScopeData.pathToNavigate = '/facility/rfid/addMembers';
      this._router.navigate(['/facility/rfid/addMembers']);
    }    
  }

  
  setDraftedFlag(changeFlag: boolean): void {
    this.rootScopeData.isPageHasUnsavedChanges = changeFlag;
  }

  openUnsavedModal(): void {
    this.showUnsavedModal = true;
  }

  onPositiveConfirmation(): void {
    this.closeUnsavedModal();
    this.rootScopeData.isPageHasUnsavedChanges = false;
    this._router.navigate(['/facility/rfid/addMembers']);
  }

  closeUnsavedModal(): void {
    this.showUnsavedModal = false;
  }

  onRefreshHandler() {
    this.onRefresh.emit();
  }
}
